module.exports = __webpack_public_path__ + "img/20f6a57263709d3ba0c6c6aa5b0ed9a0.8d3c1b2f.png";